import { UNSETTLED_ORDER_ITEMS } from "../constant/admin";

const initialState = {
  adminInfo: {
    unsettled_order_items: {},
  },
};

const AdminDeatailReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UNSETTLED_ORDER_ITEMS:
      return { ...state, adminInfo: { unsettled_order_items: payload } };
    default:
      return state;
  }
};

export default AdminDeatailReducer;
